export const trainingStatusLabel: Record<string, string> = {
  assigned: 'Назначено',
  in_progress: 'В процессе',
  completed: 'Завершено',
  failed: 'Не пройдено',
  exempt: 'Освобождён',
  cancelled: 'Отменено',
  draft: 'Черновик',
  scheduled: 'Запланировано',
  active: 'Активно',
  published: 'Опубликована',
  archived: 'Архив',
}
export const trainingStatusColor: Record<string, string> = {
  completed: 'success',
  active: 'primary',
  in_progress: 'info',
  assigned: 'warning',
  failed: 'error',
  draft: 'secondary',
  scheduled: 'info',
  cancelled: 'secondary',
  exempt: 'secondary',
  published: 'success',
  archived: 'secondary',
}
